<template>
  <div>
    <div class="box-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-6">
              <div>
                <div>
                  <label for="">{{
                    $t("receiptReceiveInfo.notiMonthlyFee")
                  }}</label>
                  <span
                    @click="onShowUpdate(InvoiceTypeEnum.MONTHLY)"
                    class="btn"
                    style="float: right;"
                    ><i class="glyphicon glyphicon-edit"></i
                  ></span>
                </div>
                <div>
                  {{ $t("apartment.apartment_code") }}:
                  {{ apartmentCode }}
                </div>
                <div>
                  {{
                    $t(
                      getOwnerOrTenantTitle(
                        receiptReceiveElectric.type
                      )
                    )
                  }}
                  :
                  {{
                    receiptReceiveElectric &&
                      receiptReceiveElectric.fullNameReceiveReceipt
                  }}
                </div>
                <div>
                  {{ $t("customer.email") }}:
                  {{
                    receiptReceiveElectric &&
                      receiptReceiveElectric.emailCustomer
                  }}
                </div>
                <div>
                  {{ $t("customer.phone") }}:
                  {{
                    receiptReceiveElectric &&
                      receiptReceiveElectric.phoneReceiveReceipt
                  }}
                </div>
                <div>
                  {{ $t("customer.address") }}:
                  {{
                    receiptReceiveElectric &&
                      receiptReceiveElectric.addressReceiveReceipt
                  }}
                </div>
                <div>
                  {{ $t("receiptReceiveInfo.emailReceiveReceipt") }}:
                  {{
                    receiptReceiveElectric &&
                      receiptReceiveElectric.emailReceiveReceipt
                  }}
                </div>
              </div>
              <hr style="margin: 10px 0" />
              <div>
                <div>
                  <label for="">{{
                    $t("receiptReceiveInfo.notiManagement")
                  }}</label>
                  <span
                    @click="onShowUpdate(InvoiceTypeEnum.QUATERLY)"
                    class="btn"
                    style="float: right;"
                    ><i class="glyphicon glyphicon-edit"></i
                  ></span>
                </div>
                <div>
                  {{ $t("apartment.apartment_code") }}:
                  {{ apartmentCode }}
                </div>
                <div>
                  {{ $t(getOwnerOrTenantTitle(receiptReceiveManagement.type)) }}
                  :
                  {{ receiptReceiveManagement && receiptReceiveManagement.fullNameReceiveReceipt }}
                </div>
                <div>
                  {{ $t("customer.email") }}:
                  {{ receiptReceiveManagement && receiptReceiveManagement.emailCustomer }}
                </div>
                <div>
                  {{ $t("customer.phone") }}:
                  {{ receiptReceiveManagement && receiptReceiveManagement.phoneReceiveReceipt }}
                </div>
                <div>
                  {{ $t("customer.address") }}:
                  {{ receiptReceiveManagement && receiptReceiveManagement.addressReceiveReceipt }}
                </div>
                <div>
                  {{ $t("receiptReceiveInfo.emailReceiveReceipt") }}:
                  {{ receiptReceiveManagement && receiptReceiveManagement.emailReceiveReceipt }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      id="modal-config-email-receive-notification"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  `receiptReceiveInfo.${
                    invoiceType === InvoiceTypeEnum.MONTHLY
                      ? "notiMonthlyFee"
                      : "notiManagement"
                  }`
                )
              }}
              ({{ apartmentCode }})
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <!-- <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("apartment.apartment_code") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    v-model="apartmentCode"
                  />
                </div>
              </div> -->
              <div class="col-md-12">
                <div class="form-group">
                  <select
                    class="form-control"
                    name=""
                    id=""
                    v-model="receiptReceiveData.typeSelect"
                    @change="onChangeTypeSelect"
                  >
                    <option
                      v-for="(item, index) in selectList"
                      :key="item + index"
                      :value="item.value"
                      >{{ $t(item.text) }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t(
                      getOwnerOrTenantTitle(receiptReceiveData.typeSelect)
                    )
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receiptReceiveData.ownerOrTenantName"
                    :disabled="receiptReceiveData.typeSelect !==
                      receiptReceiveInfoEnum.OTHER"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("customer.email")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receiptReceiveData.emailCustomer"
                    :disabled="receiptReceiveData.typeSelect !==
                      receiptReceiveInfoEnum.OTHER"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("customer.phone")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receiptReceiveData.phoneReceiveReceipt"
                    :disabled="receiptReceiveData.typeSelect !==
                      receiptReceiveInfoEnum.OTHER"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("customer.address")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receiptReceiveData.addressReceiveReceipt"
                    :disabled="receiptReceiveData.typeSelect !==
                      receiptReceiveInfoEnum.OTHER"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("receiptReceiveInfo.emailReceiveReceipt")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receiptReceiveData.emailReceiveReceipt"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onUpdate()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Enum from "../../../enum/enum";
import utils from "@/lib/utils";
//
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  },
  props: {
    apartmentId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    isLoading: false,
    receiptReceiveInfoEnum: Enum.ReceiptReceiveInfoTypeEnum,
    selectList: [
      {
        value: Enum.ReceiptReceiveInfoTypeEnum.OWNER,
        text: "customer.headOfAHousehold"
      },
      {
        value: Enum.ReceiptReceiveInfoTypeEnum.TENANT,
        text: "receiptReceiveInfo.tenantName"
      },
      {
        value: Enum.ReceiptReceiveInfoTypeEnum.OTHER,
        text: "receiptReceiveInfo.otherType"
      }
    ],
    InvoiceTypeEnum: Enum.invoiceTypeEnum,
    receiptReceiveData: {
      id: 0,
      typeSelect: Enum.ReceiptReceiveInfoTypeEnum.OWNER,
      ownerOrTenantName: null,
      emailReceiveReceipt: null,
      phoneReceiveReceipt: null,
      addressReceiveReceipt: null,
      emailCustomer: null
    },
    invoiceType: null,
    ownerResident: null,
    tenantResident: null,
    receiptReceiveElectric: {
      id: 0,
      residentData: null,
      emailReceiveReceipt: null,
      phoneReceiveReceipt: null,
      addressReceiveReceipt: null,
      fullNameReceiveReceipt: null,
      emailCustomer: null,
      type: null
    },
    receiptReceiveManagement: {
      id: 0,
      residentData: null,
      emailReceiveReceipt: null,
      phoneReceiveReceipt: null,
      addressReceiveReceipt: null,
      fullNameReceiveReceipt: null,
      emailCustomer: null,
      type: null
    },
    apartmentCode: null
  }),
  watch: {
    GET_RESIDENT_DATA: function() {
      let data = this.GET_RESIDENT_DATA;
      let ownerResidentIndex = data.findIndex(x => x.isOwner === true);
      if (ownerResidentIndex !== -1) {
        this.ownerResident = data[ownerResidentIndex];
      }
      let tenantResidentIndex = data.findIndex(x => x.isTenant === true);
      if (tenantResidentIndex !== -1) {
        this.tenantResident = data[tenantResidentIndex];
      }
    },
    APARTMENT_DETAIL_DATA: function() {
      let data = this.APARTMENT_DETAIL_DATA;
      this.apartmentCode = data.apartment_code;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_RESIDENT_DATA",
      "APARTMENT_DETAIL_DATA"
    ])
  },
  methods: {
    isWaitingLoading: function(value) {
      this.isLoading = value;
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onRefreshData: function() {
      this.getReceiptReceiveInfo();
    },
    getReceiptReceiveInfo: function() {
      let filter = {
        params: {
          apartmentId: this.apartmentId
        }
      };
      this.isWaitingLoading(true);
      this.GET_RECEIPT_RECEIVE_INFO_IN_APARTMENT(filter)
        .then(
          function(res) {
            let dataList = res;
            let receiptReceiveElectricIndex = dataList.findIndex(
              x => x.invoice_type === Enum.invoiceTypeEnum.MONTHLY
            );
            if (receiptReceiveElectricIndex !== -1) {
              let receiptReceiveElectricData =
                dataList[receiptReceiveElectricIndex];
              this.receiptReceiveElectric.id = receiptReceiveElectricData.id;
              this.receiptReceiveElectric.residentData =
                receiptReceiveElectricData.apartment_resident_data;
              this.receiptReceiveElectric.emailReceiveReceipt =
                receiptReceiveElectricData.receipt_receive_email;
              this.receiptReceiveElectric.phoneReceiveReceipt = receiptReceiveElectricData.phone
              this.receiptReceiveElectric.addressReceiveReceipt = receiptReceiveElectricData.address
              this.receiptReceiveElectric.fullNameReceiveReceipt = receiptReceiveElectricData.full_name
              this.receiptReceiveElectric.type = receiptReceiveElectricData.type
              this.receiptReceiveElectric.emailCustomer = receiptReceiveElectricData.email
            } else {
              this.receiptReceiveElectric.id = 0;
              this.receiptReceiveElectric.residentData = null;
              this.receiptReceiveElectric.emailReceiveReceipt = null;
              this.receiptReceiveElectric.phoneReceiveReceipt = null
              this.receiptReceiveElectric.addressReceiveReceipt = null
              this.receiptReceiveElectric.fullNameReceiveReceipt = null
              this.receiptReceiveElectric.type = null
              this.receiptReceiveElectric.emailCustomer = null
            }
            let receiptReceiveManagementIndex = dataList.findIndex(
              x => x.invoice_type === Enum.invoiceTypeEnum.QUATERLY
            );
            if (receiptReceiveManagementIndex !== -1) {
              let receiptReceiveManagementData =
                dataList[receiptReceiveManagementIndex];
              this.receiptReceiveManagement.id =
                receiptReceiveManagementData.id;
              this.receiptReceiveManagement.residentData =
                receiptReceiveManagementData.apartment_resident_data;
              this.receiptReceiveManagement.emailReceiveReceipt =
                receiptReceiveManagementData.receipt_receive_email;
              this.receiptReceiveManagement.phoneReceiveReceipt = receiptReceiveManagementData.phone
              this.receiptReceiveManagement.addressReceiveReceipt = receiptReceiveManagementData.address
              this.receiptReceiveManagement.fullNameReceiveReceipt = receiptReceiveManagementData.full_name
              this.receiptReceiveManagement.type = receiptReceiveManagementData.type
              this.receiptReceiveManagement.emailCustomer = receiptReceiveManagementData.email
            } else {
              this.receiptReceiveManagement.id = 0;
              this.receiptReceiveManagement.residentData = null;
              this.receiptReceiveManagement.emailReceiveReceipt = null;
              this.receiptReceiveManagement.phoneReceiveReceipt = null
              this.receiptReceiveManagement.addressReceiveReceipt = null
              this.receiptReceiveManagement.type = null
              this.receiptReceiveManagement.emailCustomer = null
            }
            this.isWaitingLoading(false);
          }.bind(this)
        )
        .catch(
          function() {
            this.isWaitingLoading(false);
          }.bind(this)
        );
    },
    //
    onCloseModal: function() {
      $("#modal-config-email-receive-notification").modal("hide");
    },
    onShowModal: function() {
      $("#modal-config-email-receive-notification").modal("show");
    },
    onShowUpdate: function(value) {
      this.invoiceType = value;
      switch (value) {
        case Enum.invoiceTypeEnum.MONTHLY:
          this.receiptReceiveData.id = this.receiptReceiveElectric.id;
          this.getIsOwner(this.receiptReceiveElectric.residentData, this.receiptReceiveElectric);
          this.getReceiptReceiveInfoDetail();
          break;
        case Enum.invoiceTypeEnum.QUATERLY:
          this.receiptReceiveData.id = this.receiptReceiveManagement.id;
          this.getIsOwner(this.receiptReceiveManagement.residentData, this.receiptReceiveManagement);
          this.getReceiptReceiveInfoDetail();
          break;
        default:
          break;
      }
      this.onShowModal();
    },
    getIsOwner: function(resident_data, receiveReceiptInfo) {
      if (receiveReceiptInfo.type === null)
        this.receiptReceiveData.typeSelect = this.receiptReceiveInfoEnum.OWNER;
      else {
        this.receiptReceiveData.typeSelect = receiveReceiptInfo.type;
      }
      if (utils.isEmptyString(this.receiptReceiveData.emailReceiveReceipt)) {
        this.receiptReceiveData.emailReceiveReceipt = this.ownerResident && this.ownerResident.resident.email;
      }
    },
    onChangeTypeSelect: function() {
      this.getReceiptReceiveInfoDetail();
    },
    onUpdate: function() {
      if (utils.isEmptyString(this.receiptReceiveData.emailReceiveReceipt)) {
        this.showError('receiptReceiveInfo.emailReceiveReceipt')
      } else {
        let data = {
          id: this.receiptReceiveData.id,
          apartmentId: this.apartmentId,
          invoiceType: this.invoiceType,
          emailReceiveReceipt: this.receiptReceiveData.emailReceiveReceipt,
          receiptReceiveInfoType: this.receiptReceiveData.typeSelect,
          receiveReceiptFullName: null,
          phoneReceiveReceipt: this.receiptReceiveData.phoneReceiveReceipt,
          addressReceiveReceipt: this.receiptReceiveData.addressReceiveReceipt,
          fullName: this.receiptReceiveData.ownerOrTenantName,
          email: this.receiptReceiveData.emailCustomer
        };
        this.isWaitingLoading(true);
        this.POST_RECEIPT_RECEIVE_INFO(data)
          .then(
            function() {
              this.onRefreshData();
              this.onCloseModal();
              this.isWaitingLoading(false);
            }.bind(this)
          )
          .catch(
            function(error) {
              let mess = error.response.data.message;
              this.showError(mess);
              this.isWaitingLoading(false);
            }.bind(this)
          );
      }
    },
    getOwnerOrTenantTitle: function(type) {
      if (type === this.receiptReceiveInfoEnum.OWNER) {
        return "customer.headOfAHousehold";
      }
      if (type === this.receiptReceiveInfoEnum.TENANT) {
        return "receiptReceiveInfo.tenantName";
      }
      return "customer.fullname"
    },
    getReceiptReceiveInfoDetail: function() {
      let filter = {
        params: {
          apartmentId: this.apartmentId,
          invoiceType: this.invoiceType,
          receiptReceiveInfoType: this.receiptReceiveData.typeSelect
        }
      };
      this.isWaitingLoading(true);
      this.GET_RECEIPT_RECEIVE_INFO_DETAIL(filter)
        .then(
          function(res) {
            let data = res;
            if (Object.keys(data).length > 0) {
              this.receiptReceiveData.id = data.id;
              this.receiptReceiveData.emailReceiveReceipt =
                data.receipt_receive_email;
              if (data.type === this.receiptReceiveInfoEnum.OTHER) {
                this.receiptReceiveData.ownerOrTenantName = data.full_name
              } else {
                this.receiptReceiveData.ownerOrTenantName =
                  data.apartment_resident_data.full_name;
              }
              this.getIsOwner(data.apartment_resident_data, data);
              this.receiptReceiveData.phoneReceiveReceipt = data.phone
              this.receiptReceiveData.addressReceiveReceipt = data.address
              this.receiptReceiveData.emailCustomer = data.email
            } else {
              if (
                this.receiptReceiveData.typeSelect ===
                this.receiptReceiveInfoEnum.OWNER
              ) {
                this.receiptReceiveData.emailReceiveReceipt =
                  this.ownerResident && this.ownerResident.resident.email;
                this.receiptReceiveData.ownerOrTenantName = !utils.isNull(this.ownerResident)
                  ? this.ownerResident.resident.last_name +
                    " " +
                    this.ownerResident.resident.first_name
                  : null;
                this.receiptReceiveData.addressReceiveReceipt = this.ownerResident && this.ownerResident.resident.address
                this.receiptReceiveData.phoneReceiveReceipt = this.ownerResident && this.ownerResident.resident.phone
                this.receiptReceiveData.emailCustomer =
                  this.ownerResident && this.ownerResident.resident.email;
              }
              if (
                this.receiptReceiveData.typeSelect ===
                this.receiptReceiveInfoEnum.TENANT
              ) {
                this.receiptReceiveData.emailReceiveReceipt =
                  this.tenantResident && this.tenantResident.resident.email;
                this.receiptReceiveData.ownerOrTenantName = !utils.isNull(this.tenantResident)
                  ? this.tenantResident.resident.last_name +
                    " " +
                    this.tenantResident.resident.first_name
                  : null;
                this.receiptReceiveData.addressReceiveReceipt = this.tenantResident && this.tenantResident.resident.address
                this.receiptReceiveData.phoneReceiveReceipt = this.tenantResident && this.tenantResident.resident.phone
                this.receiptReceiveData.emailCustomer =
                  this.tenantResident && this.tenantResident.resident.email;
              }
              if (
                this.receiptReceiveData.typeSelect ===
                this.receiptReceiveInfoEnum.OTHER
              ) {
                this.receiptReceiveData.emailReceiveReceipt = null
                this.receiptReceiveData.ownerOrTenantName = null
                this.receiptReceiveData.phoneReceiveReceipt = null
                this.receiptReceiveData.addressReceiveReceipt = null
                this.receiptReceiveData.emailCustomer = null
              }
            }
            this.isWaitingLoading(false);
          }.bind(this)
        )
        .catch(
          function(error) {
            // let mess = error.response.data.message;
            // this.showError(mess);
            this.isWaitingLoading(false);
          }.bind(this)
        );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_RECEIPT_RECEIVE_INFO_IN_APARTMENT",
      "POST_RECEIPT_RECEIVE_INFO",
      "GET_RECEIPT_RECEIVE_INFO_DETAIL"
    ])
  },
  created() {
    if (this.apartmentId !== null && this.apartmentId !== 0) {
      //
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Apartment/ReceiptReceiveInfo.vue